module.exports = __webpack_public_path__ + "img/easyload-xl.0f07ca72.gif";